import React, { forwardRef } from 'react';
import { TextField, TextFieldProps, useTheme } from '@material-ui/core';
import 'react-phone-number-input/style.css';
import PhoneInput from 'react-phone-number-input';

const PhoneInputRef = forwardRef<HTMLInputElement, TextFieldProps>((props, ref) => {
  const theme = useTheme();
  const { required = true } = props;
  return (
    <TextField
      {...props}
      color="secondary"
      className="input-field"
      variant="outlined"
      margin="normal"
      fullWidth
      required={required}
      inputRef={ref}
      label={props.placeholder}
      InputLabelProps={{
        shrink: true,
        style: { color: props.error ? theme.palette.error.main : theme.palette.grey[700] },
      }}
    />
  );
});

type PhoneNumberInputProps = {
  placeholder: string;
  value: string;
  id: string;
  onChange: (value: string) => void;
  onBlur: (e: React.FocusEvent<HTMLInputElement>) => void;
  error: boolean;
  helperText: string;
  required?: boolean;
};

export const PhoneNumberInput: React.FC<PhoneNumberInputProps> = ({
  placeholder,
  value,
  id,
  onChange,
  onBlur,
  error,
  helperText,
  required,
}) => (
  <PhoneInput
    placeholder={placeholder}
    value={value}
    onChange={onChange}
    onBlur={onBlur}
    defaultCountry="US"
    countryOptionsOrder={['US', 'GB']}
    id={id}
    inputComponent={PhoneInputRef}
    numberInputProps={{ error, helperText, required: required ?? true }}
  />
);
